import { createLogger } from "logging";

const logger = createLogger("helpers/numbers");

const numberFormat = new Intl.NumberFormat("de-CH", {
  numberingSystem: "ansi",
});

export function formatFileSize(fileSize?: number) {
  if (!fileSize) {
    return "";
  }

  if (fileSize <= 0) {
    return "";
  }

  return `${(parseFloat(`${fileSize}`) / 1024.0).toFixed(2)} KB`;
}

export function formatNumber(input: number): string {
  const r = numberFormat.format(input);
  if (`${input}` !== r) logger.trace(`formatNumber():  `, input, r);

  return r;
}

export function leadZero(input: number) {
  const r = input < 10 ? `0${input}` : String(input);
  if (`${input}` !== r) logger.trace(`leadZero():  `, input, r);

  return r;
}
